import { render, staticRenderFns } from "./MobileCarousel.vue?vue&type=template&id=44327cd4&scoped=true&"
import script from "./MobileCarousel.vue?vue&type=script&lang=ts&"
export * from "./MobileCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./MobileCarousel.vue?vue&type=style&index=0&id=44327cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44327cd4",
  null
  
)

export default component.exports